import { PageContent } from 'components/layout/PageContent'
import { useIframesAtendimentoQuery } from 'graphql/hooks.generated'
import React from 'react'
import { useParams } from 'react-router-dom'
import { TipoAtendimentoFooter } from 'view/atendimentos/model-atendimento'

import { AtendimentoFooter } from '../AtendimentoFooter'
import { SistemasExternosAtendimentoDetail } from './SistemasExternosAtendimentoDetail'
import { SistemasExternosAtendimentoList } from './SistemasExternosAtendimentoList'

interface SistemasExternosAtendimentoViewProps {
  atendimentoId: ID
  atendimentoProfissionalId: ID
  tipoAtendimentoProfissional?: TipoAtendimentoFooter
  isRegistroTardio?: boolean
  clearCache(updateState?: boolean): void
  isAtendimentoObservacao?: boolean
  isObservacaoAndResponsavel?: boolean
}

export interface AtendimentoIframe {
  id: string
  nome: string
  url: string
}

export function SistemasExternosAtendimentoView(props: Readonly<SistemasExternosAtendimentoViewProps>) {
  const {
    atendimentoId,
    atendimentoProfissionalId,
    clearCache,
    tipoAtendimentoProfissional,
    isRegistroTardio = false,
    isAtendimentoObservacao = false,
    isObservacaoAndResponsavel = false,
  } = props

  const { data } = useIframesAtendimentoQuery({ variables: { atendimentoProfissionalId } })

  const { iframeId } = useParams<{ iframeId: string }>()

  const iframeSelecionado: AtendimentoIframe | null = iframeId
    ? data?.iframesAtendimento?.find((iframe) => iframe.id === iframeId)
    : null

  return (
    <>
      <PageContent fluid type='filled'>
        {iframeSelecionado ? (
          <SistemasExternosAtendimentoDetail atendimentoIframe={iframeSelecionado} />
        ) : (
          <SistemasExternosAtendimentoList items={data?.iframesAtendimento ?? []} />
        )}
      </PageContent>

      <AtendimentoFooter
        atendimentoId={atendimentoId}
        tipoAtendimentoProfissional={tipoAtendimentoProfissional}
        clearCache={clearCache}
        isRegistroTardio={isRegistroTardio}
        isAtendimentoObservacao={isAtendimentoObservacao}
        isObservacaoAndResponsavel={isObservacaoAndResponsavel}
      />
    </>
  )
}
